import { Component, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";
import { BaseModalComponent } from "../base-modal/base-modal.component";
import {
  filterModalAnimationsEnterLeave,
  filterModalAnimationsEnterLeaveFade,
} from "../filter-modal/filter-modal.animations";

@Component({
    selector: "app-info-modal",
    templateUrl: "./info-modal.component.html",
    styleUrls: ["./info-modal.component.scss"],
    // `animations` is decorator metadata and is not inherited from
    // BaseModalComponent, so the triggers this template names have to be
    // registered here or rendering fails with NG03401.
    animations: [
      filterModalAnimationsEnterLeave,
      filterModalAnimationsEnterLeaveFade,
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoModalComponent extends BaseModalComponent {
  constructor() {
    super();
  }
}
